import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Geocoder } from '@geocode-models/geocoder.model';
import { SuggestMatchResult } from '@geocode-models/suggest-match-result.model';
import { SuggestRequest } from '@geocode-models/suggest-request.model';
import { PremiseHazardRestBase } from './premise-hazard-rest-base';
import { VerifyInput } from '@geocode-models/verify-input.model';
import { VerifyResult } from '@geocode-models/verify-result.model';
import { VerifyRequest } from '@geocode-models/verify-request.model';

@Injectable({
  providedIn: 'root',
})
export class GeocodingRestService extends PremiseHazardRestBase {
  private AlwaysGeocode: boolean = true;
  private DefaultGeocoders: Geocoder[] = [Geocoder.esriOnline, Geocoder.utahGeocoder, Geocoder.msiGeocoder, Geocoder.customEsriLocator];

  public suggest(
    address: string,
    city: string | undefined = undefined,
    countryCode: string | undefined = undefined,
    geocoder: Geocoder | undefined = undefined,
    includeCommonPlaces: boolean = true,
    maxSuggestions: number | undefined = undefined,
  ): Observable<SuggestMatchResult[]> {
    let requestBody: SuggestRequest = {
      address: address,
      msiProduct: this.MsiProduct,
      city: city,
      countryCode: countryCode,
      geocoder: geocoder,
      geocoders: this.DefaultGeocoders,
      includeCommonPlaces: includeCommonPlaces,
      maxSuggestions: maxSuggestions,
      searchExtent: undefined,
      searchLocation: undefined,
    };
    const opts = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
      })
    };
    const url = this.getGeocodingUrl(GeocodingEndpoint.Suggest);
    return this.httpClient.post<SuggestMatchResult[]>(url, requestBody, opts);
  }

  public verifyForStorage(verifyInput: VerifyInput, geocoder: Geocoder): Observable<VerifyResult[]> {
    return this.verify(verifyInput, true, geocoder);
  }

  // call geoverfication API
  public verify(
    verifyInput: VerifyInput,
    forStorage: boolean = false,
    geocoder: Geocoder | undefined = undefined
  ): Observable<VerifyResult[]> {
    const geocoders: Geocoder[] = geocoder ? [geocoder] : this.DefaultGeocoders;
    const verifyRequest: VerifyRequest = {
      address: verifyInput.address,
      apartment: verifyInput.apartment,
      building: verifyInput.building,
      city: verifyInput.city,
      floor: verifyInput.floor,
      locationName: verifyInput.locationName,
      magicKey: verifyInput.magicKey,
      subdivision: verifyInput.subdivision,
      zipCode: verifyInput.zipCode,
      alwaysGeocode: this.AlwaysGeocode,
      forStorage: forStorage,
      msiProduct: this.MsiProduct,
      geocoder: geocoder,
      geocoders: geocoders,
    };
    const opt = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const url = this.getGeocodingUrl(GeocodingEndpoint.Verify);
    return this.httpClient.post<VerifyResult[]>(
      url,
      verifyRequest,
      opt
    );
  }

  private getGeocodingUrl(endpoint: GeocodingEndpoint): string {
    const endpointString: string = endpoint;
    const customerId: string = this.userInfo.isSuperAdmin ? this.userInfo.selectedCustomerId! : this.userInfo.customerId;
    const agencyId: string = this.userInfo.isSuperAdmin ? this.userInfo.selectedCustomerId! : this.userInfo.agencyId;
    return `${this.geoVerificationUrl}/${customerId}/${agencyId}/address/${endpointString}`
  }
}

enum GeocodingEndpoint {
  Suggest = "suggest",
  Verify = "verify"
}
